import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { getCaloriesPerMacro } from "@notemeal/shared-utils-macro-protocol";
import { ColoredProgressDial } from "../universal/ColoredProgressDial";
import { LabeledProgressDial } from "../universal/LabeledProgressDial";
const useStyles = makeStyles({
    cho: {
        color: "green",
    },
    pro: {
        color: "blue",
    },
    fat: {
        color: "red",
    },
});
const MacroProgressDial = ({ current, target, variant, hideNumbers, macro }) => {
    const classes = useStyles();
    const text = macro === "cho" ? "CHO" : macro === "pro" ? "PRO" : "FAT";
    const color = macro === "cho" ? classes.cho : macro === "pro" ? classes.pro : classes.fat;
    return (_jsx(LabeledProgressDial, { variant: variant, hideNumbers: hideNumbers, label: _jsx(Typography, { color: "inherit", className: color, variant: variant === "lg" ? "h6" : variant === "md" ? "body1" : "caption", children: text }), labelText: text, current: current, target: target, unit: "g" }));
};
const TargetMacroProgressDials = ({ current, target, variant, hideNumbers }) => {
    return (_jsxs(_Fragment, { children: [_jsx(MacroProgressDial, { hideNumbers: hideNumbers, variant: variant, current: current.cho, target: target.cho, macro: "cho" }), _jsx(MacroProgressDial, { hideNumbers: hideNumbers, variant: variant, current: current.pro, target: target.pro, macro: "pro" }), _jsx(MacroProgressDial, { hideNumbers: hideNumbers, variant: variant, current: current.fat, target: target.fat, macro: "fat" })] }));
};
const ColoredMacroProgressDial = ({ value, total, hideNumbers, variant, macro }) => {
    const classes = useStyles();
    const macroLabel = macro === "cho" ? "CHO" : macro === "pro" ? "PRO" : "FAT";
    const color = macro === "cho" ? classes.cho : macro === "pro" ? classes.pro : classes.fat;
    const formattedPercent = total > 0 ? Math.round((value / total) * 100) : 0;
    const formattedRawValue = Math.round(value);
    const insetLabel = hideNumbers ? formattedPercent + "%" : formattedRawValue + "g";
    return (_jsx(ColoredProgressDial, { variant: variant, color: color, label: _jsx(Typography, { color: "inherit", className: color, variant: variant === "lg" ? "h6" : variant === "md" ? "body1" : "caption", children: macroLabel }), insetLabel: insetLabel, macroLabel: macroLabel }));
};
const ColoredMacroProgressDials = ({ macros, hideNumbers, variant }) => {
    const { cho, pro, fat } = hideNumbers ? getCaloriesPerMacro(macros) : macros;
    const { kcal: total } = macros;
    return (_jsxs(_Fragment, { children: [_jsx(ColoredMacroProgressDial, { hideNumbers: hideNumbers, variant: variant, value: cho, total: total ?? 0, macro: "cho" }), _jsx(ColoredMacroProgressDial, { hideNumbers: hideNumbers, variant: variant, value: pro, total: total ?? 0, macro: "pro" }), _jsx(ColoredMacroProgressDial, { hideNumbers: hideNumbers, variant: variant, value: fat, total: total ?? 0, macro: "fat" })] }));
};
export const ToggleableMacroDials = ({ macros, targetMacros, variant, mode }) => {
    if ((mode === "HasTargets_HideNumbers" || mode === "HasTargets_ShowNumbers") && targetMacros) {
        return (_jsx(TargetMacroProgressDials, { hideNumbers: mode === "HasTargets_HideNumbers", variant: variant, current: macros, target: targetMacros }));
    }
    else if (mode === "NoTargets_HideNumbers" || mode === "NoTargets_ShowNumbers") {
        return _jsx(ColoredMacroProgressDials, { hideNumbers: mode === "NoTargets_HideNumbers", variant: variant, macros: macros });
    }
    else {
        return null;
    }
};
//# sourceMappingURL=ProgressDials.js.map